import React from 'react';

const FeedShareIcon = ({ width = 16, height = 13 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0043 3.98066V2.46014C11.0043 1.60903 11.9865 1.17869 12.5595 1.78116L16.734 6.1706C17.0887 6.54356 17.0887 7.14603 16.734 7.51898L12.5595 11.9084C11.9865 12.5109 11.0043 12.0901 11.0043 11.239V9.62285C6.9196 9.62285 3.93565 10.8574 1.72283 13.5344C1.54996 13.7435 1.1947 13.5858 1.26217 13.323C2.38263 8.95822 5.16125 4.85835 11.0043 3.98066Z"
      stroke="#5D5D6B"
      strokeWidth="1.3"
    />
  </svg>
);

export default FeedShareIcon;
